import { SOFTPHONES_KEY } from '../constants/constants';
import { callReceivedToModel } from '../mappers/models.mapper';
let instance = null;
export class SingletonSharedData{
    constructor() {
		if (!instance) {
			instance = this;
		}
		this.volumeSpeaker = 50;
		this.volumeMic = 50;
		this.currentSoftPhone = SOFTPHONES_KEY.WEBRTC;
		this.problemInManualCall = false;
		this.ipAddress = '';
		this.ipAddressAPI = '';
		this.chatsList = {};
		this.chatListNotReaded = {};
		this.currentTimeInState = 0;
		this.isLogged = false;
		this.manualCallTime = 0;
		this.XferTime = 0;
		this.supervisorChat = '';
		this.textToSendSupervisorChat = '';
		this.currentCallTime = '';
		this.extraCallsConference = 0;
		this.hasUnifiedMessage = false;
		this.currentState = ''; 
		this.assistedTransferState = '';
		this.requestTimeout = 60000;
		this.isPreview = false;
		this.isAssisted = false;
		this.selectedConversationId = 0;
		this.isIntegration = false;
		this.isIntegrationManualCall = false;
		this.secureConnection = false;
		this.callOutCampaigns = null;
		this.versionAgentKolob = '';
		this.country = '';
		this.campID = '';
		this.focusTel = false;
		this.isRated = false;
		this.isPendingMessage = false;
		this.audioNotificationCallIn = null;
		this.AllowMarksPermission = true;
		this.callIcon=null;
		this.integrationCallData=null;
		this.sendDataOncallout=false;
		this.aniList=[];
		this.isANIListEmpty=false;
		this.agentList=[];
		this.doConnectCall=true;
		this.domain='';
		this.isDispositionSaved = false;
		this.startStopRecording=false;
		this.isStopRecording=false;
		this.prevVolumenMicro=50;
		this.isMute=false;
		this.isHold=false;
		this.permissionHoldCamp=true;
		this.callsQueue=[];
        this.audioPathUser = '';
		this.audioDefaultDuration = 0;
        this.connectedTransfer=false;
		this.isBlindTranferActive = false;
		this.mainCall=true;
		this.watcherStatusCall = 0;
		this.isManualCallScheduled = false;  
		this.lastIdCampManualCall = 0;
		this.lastCall = {};
		this.isAssistedMode = false;
		this.exitAssistedFromDispositions = [];
		this.isProblemStatus = false;
		this.temporalCallData = {};
		this.isCallTypeInbound = false;
		this.lastCallDataInbound = [];
		this.lastCallDataOutbound = [];
		this.showToolsTransfers = false;
		this.isShowToolsTransfersActive = false;
		this.isTransferAssisted = false;
		this.isHangedUpByAgent = 0;
		this.audioNotificationCallStart = null;
		this.audioNotificationCallEnd = null;
		return instance;
	}

	getCurrentTime () {
		const now = new Date();
		const hours = String(now.getHours()).padStart(2, '0');
		const minutes = String(now.getMinutes()).padStart(2, '0');
		const seconds = String(now.getSeconds()).padStart(2, '0');
		const timeString = `${hours}:${minutes}:${seconds}`;
		return timeString;
	}

	setExitAssistedMode (Dispositions) {
		const exitAssistedMode = Object.values(Dispositions).map(disposition => {
			return {
				Id: disposition.Id,
				FinishPreview: disposition.FinishPreview
			};
		});
		this.exitAssistedFromDispositions = exitAssistedMode;
	}

	getExitAssistedMode (dispositionID) {
		const found = this.exitAssistedFromDispositions.find(item => item.Id === dispositionID);
		return found ? found.FinishPreview : false;
	}

	setAllowMarksPermission(value){
		this.AllowMarksPermission = value;
	}

	getAllowMarksPermission(){
		return this.AllowMarksPermission;
	}
	setIsRated(value) {
		this.isRated = value;
	}
	getIsRated() {
		return this.isRated;
	}
	setVolumeSpeaker(volumeSpeaker) {
		this.volumeSpeaker = volumeSpeaker;
	}
	getVolumeSpeaker() {
		return this.volumeSpeaker;
	}
	setVolumeMic(volumeMic) {
		this.volumeMic = volumeMic;
	}
	getVolumeMic() {
		return this.volumeMic;
	}
	setIPAddress(ipAddress) {
		this.ipAddress = ipAddress;
	}
	getIPAddress() {
		return this.ipAddress;
	}
	setCampaingID(campID) {
		this.campID = campID;
	}
	getCampaingID() {
		return this.campID;
	}
	setIPfromAPI(ipAddressAPI) {
		this.ipAddressAPI = ipAddressAPI;
	}
	getIPfromAPI() {
		return this.ipAddressAPI;
	}
	getCurrentState() {
		return this.currentState;
	}
	setCurrentState(currentState) {
		if (this.currentState !== currentState) {
			console.info(`State changed from ${this.currentState} to ${currentState}`);
			this.currentState = currentState;
		}	
	}

	setSoftPhone(softPhone) {
		this.currentSoftPhone = softPhone;
	}

	getSoftPhone() {
		return this.currentSoftPhone;
	}

	setLogged(logged) {
		this.isLogged = logged;
	}

	getLogged() {
		return this.isLogged;
	}

	setUserData(user) {
		this.user = user;
	}
	
	setPhoneNumber(phoneNumber) {
		this.phoneNumber = phoneNumber;
	}
	setParameters(parameters) {
		this.parameters = parameters;
	}

	setPermissions(permissions) {
		this.permissions = {
			...permissions
		};
	}

	setGeneralPermissions(generalPermissions) {
		this.generalPermissions = generalPermissions;
	}
	setCallOutCampaigns(callOutCampaigns) {
		this.callOutCampaigns = callOutCampaigns;
	}
	setANIListCampaign(aniList){
		this.aniList = aniList;
	}
	setIsANIListEmpty(isANIListEmpty){
		this.isANIListEmpty = isANIListEmpty;
	}
	setCurrentTimeInState(currentTime) {
		this.currentTimeInState = currentTime;
	}

	getUserData() {
		return this.user;
	}

	getPhoneNumber() {
		return this.phoneNumber;
	}

	getParameters() {
		return this.parameters;
	}

	getPermissions() {
		return this.permissions;
	}

	getGeneralPermissions() {
		return this.generalPermissions;
	}
	setSupervisorList(supervisorList) {
		this.supervisorList = supervisorList;
		this.supervisorObserver(supervisorList);
	}
	observerSupervisor(supervisorObserver) {
		this.supervisorObserver = supervisorObserver;
	}
	getSupervisorList() {
		return this.supervisorList;
	}

	clearChatList() {
		this.chatsList = {};
	}
	setObjectChat(object, chatList) {
		if (!this.chatsList[chatList]) {
			this.chatsList[chatList] = [];
		}
		this.chatsList[chatList].push(object);
	}
	getChatList(chatList) {
		if (typeof this.chatsList[chatList] === 'undefined') {
			return [];
		}
		return this.chatsList[chatList];
	}
	setNewNotificationChat(chatList, resetChat = false) {
		if (!this.chatListNotReaded[chatList]) {
			this.chatListNotReaded[chatList] = 1;
		} else {
			this.chatListNotReaded[chatList]++;
		}
		if (resetChat) {
			this.chatListNotReaded[chatList] = 0;
		}
	}
	getNotificationChat(chatList) {
		return this.chatListNotReaded[chatList];
	}
	setCurrentSuperVisor(supervisor) {
		this.supervisorChat = supervisor;
	}
	getCurrentSuperVisor() {
		return this.supervisorChat;
	}
	setTextToSend(textToSend) {
		this.textToSendSupervisorChat = textToSend;
	}
	getTextToSend() {
		return this.textToSendSupervisorChat;
	}
	setCurrentCallTime(currentCallTime) {
		this.currentCallTime = currentCallTime;
	}
	getCurrentCallTime() {
		return this.currentCallTime;
	}

	setManualCallTime(time) {
		this.manualCallTime = time;
	}
	getManualCallTime() {
		return this.manualCallTime;
	}
	setXferTime(time) {
		this.XferTime = time;
	}
	getXferTime() {
		return this.XferTime;
	}
	setConferenceCallID(callID) {
		this.conferenceCallID = callID;
	}
	getConferenceCallID() {
		return this.conferenceCallID;
	}
	setConferenceHangUpOther(callID) {
		this.conferenceHangUpOther = callID;
	}
	getConferenceHangUpOther() {
		return this.conferenceHangUpOther;
	}
	addCallConference() {
		this.extraCallsConference++;
	}
	substractCallConference() {
		this.extraCallsConference--;
	}
	getextraCallsConference() {
		return this.extraCallsConference;
	}
	setCallConferencetoZero() {
		this.extraCallsConference = 0;
	}
	setConferenceNewNumber(newNumber) {
		this.conferenceNewNumber = newNumber;
	}
	getConferenceNewNumber() {
		return this.conferenceNewNumber;
	}

	getSecureConnection() {
		return this.secureConnection;
	}
	setSecureConnection(secureConnection) {
		this.secureConnection = secureConnection;
	}
	setVersionAgent(versionAgentKolob) {
		this.versionAgentKolob = versionAgentKolob;
	}
	getVersionAgent() {
		return this.versionAgentKolob;
	}
	setCountry(country) {
		this.country = country;
	}
	getCountry() {
		return this.country;
	}
	setFocusTel(focusTel) {
		this.focusTel = focusTel;
	}
	getFocusTel() {
		return this.focusTel;
	}
	getAssistedTransferCurrentState() {
		return this.assistedTransferState;
	}
	setAssistedTransferCurrentState(assistedTransferState) {
		this.assistedTransferState = assistedTransferState;
	}
	setRequestTimeout(requestTimeout) {
		let castNumber = parseInt(requestTimeout, 10);
		if (Number.isInteger(castNumber)) {
			this.requestTimeout = castNumber;
		}
	}
	getRequestTimeout() {
		return this.requestTimeout;
	}
	setIsAssisted(isAssisted) {
		this.isAssisted = isAssisted;
	}
	getIsAssisted() {
		return this.isAssisted;
	}
	setDataAssistedCall(dataCall) {
		this.dataObject = {
			campaingName: dataCall.CampaignName,
			iconCampaing: dataCall.GraphId,
			calKey: dataCall.CallKey,
			Id: dataCall.CamId,
			iconCall: '1',
			enableBtnAssistedCall: dataCall.ExitAssistedDialMode,
			CallOutId:dataCall.CallOutId
		};
		this.phoneNumber = dataCall.PhoneNumber;
	}
	getDataAssistedCall() {
		return this.dataObject;
	}
	getIsEnableBtnExitAssited() {
		return this.dataObject.enableBtnAssistedCall;
	}
	getIsPendingMessage() {
		return this.isPendingMessage;
	}
	setIsPendingMessage(isPendingMessage) {
		this.isPendingMessage = isPendingMessage;
	}
	getSelectedConversationId() {
		return this.selectedConversationId;
	}
	setSelectedConversationId(conversationId) {
		this.selectedConversationId = conversationId;
	}
	getPrevNotificationError() {
		return this.prevNotificationError;
	}
	setPrevNotificationError(value) {
		this.prevNotificationError = value;
	}
	
	setAudioNotificationCallIn(audio){
		this.audioNotificationCallIn = audio;
	}
	getAudioNotificationCallIn(){
		return this.audioNotificationCallIn;
	}
	setCallIcon(callIcon) {
        this.callIcon = callIcon;
    }
    getCallIcon() {
        return this.callIcon;
    }
	setIntegrationCallData(integrationCallData) {
        this.integrationCallData = integrationCallData;
    }
    getIntegrationCallData() {
        return this.integrationCallData;
    }
	setSendDataOncallout(send) {
        this.sendDataOncallout = send;
    }
    getSendDataOncallout() {
        return this.sendDataOncallout;
    }
	setAgentList(agentList) {
		this.agentList = agentList;
	}
	getAgentList() {
		return this.agentList;
	}
	setDoConnectCall(flag) {
		this.doConnectCall = flag;
	}
	getDoConnectCall() {
		return this.doConnectCall;
	}
	setDomain(domain) {
		this.domain = domain;
	}
	getDomain() {
		return this.domain;
	}
	setStartStopRecording(isActive){
		this.startStopRecording=isActive;
	}
	getStartStopRecording(){
		return this.startStopRecording;
	}
	setIsStopRecording(isActive){
		this.isStopRecording=isActive;
	}
	getIsStopRecording(){
		return this.isStopRecording;
	}
	setPrevVolumenMicro(volume){
		this.prevVolumenMicro=volume;
	}
	getPrevVolumenMicro(){
		return this.prevVolumenMicro;
	}
	
	setIsMute(isActive){
		this.isMute=isActive;
	}
	getIsMute(){
		return this.isMute;
	}

	setIsHold(isActive){
		this.isHold=isActive;
	}
	getIsHold(){
		return this.isHold;
	}
	
	setPermissionHoldCamp(isActive){
		this.permissionHoldCamp=isActive;
	}
	getPermissionHoldCamp(){
		return this.permissionHoldCamp;
	}

	setCallsOnQueue(callsQueue){
		this.callsQueue = callsQueue;
	}

	getCallsOnQueue(){
		return this.callsQueue;
	}
	
	setConnectedTransfer(isConnect){
		this.connectedTransfer = isConnect;
	}

	getConnectedTransfer(){
		return this.connectedTransfer;
	}

	setMainCall(isMain){
		this.mainCall = isMain;
	}

	getMainCall(){
		return this.mainCall;
	}

	setTemporalCallData(obj, action) {
		const callReceivedData = callReceivedToModel(obj);
		callReceivedData.callId = Math.abs(callReceivedData.callId);
		const defaultValues = { waitingTime: 0, isQueueCall: 0, holdTime: 0, port: 0 }; 
		for (const key in defaultValues) { 
			callReceivedData[key] = callReceivedData[key] ?? defaultValues[key];
		}
		switch (action) {
			case "callReceived":
				Object.assign(
					this.temporalCallData,
					callReceivedData
				);
				break;
			case "updateDataCall":
				Object.assign(
					this.temporalCallData, 
					{ callKey: obj.callKey || '' },
					{ dataContact: obj.Data || ['', null, null, null, null] }
				);
				break;
			case "callEnds":
				Object.assign(
					this.temporalCallData, 
					{ dialogTime: obj.dialogTime || 0 }
				);
				break;
			default:
				break;
		}
		
	}

	getLastCallDataInbound() {
		return this.lastCallDataInbound;
	}

	setLastCallDataInbound() {
		Object.assign(this.lastCallDataInbound, this.temporalCallData);
	}

	getLastCallDataOutbound() {
		return this.lastCallDataOutbound;
	}

	setLastCallDataOutbound() {
		Object.assign(this.lastCallDataOutbound, this.temporalCallData);
	}
	setToolsTransfer(options) {
		this.showToolsTransfers = options?.AgentXfer ?? false;
		this.isTransferAssisted = options?.TransferAssisted ?? false;
	}

	getToolsTransfer() {
		return {
			showOptionsOnTransfer: this.showToolsTransfers,
			isTransferAssisted: this.isTransferAssisted
		};
	}

	setIsHangedUpByAgent(isHangedUp){
		this.isHangedUpByAgent = isHangedUp;
	}
	getIsHangedUpByAgent(){
		return this.isHangedUpByAgent;
	}

	setAudioNotificationCallStart(audio){
		this.audioNotificationCallStart = audio;
	}
	getAudioNotificationCallStart(){
		return this.audioNotificationCallStart;
	}
	setAudioNotificationCallEnd(audio){
		this.audioNotificationCallEnd = audio;
	}
	getAudioNotificationCallEnd(){
		return this.audioNotificationCallEnd;
	}




}
